import React from 'react';
import PropTypes from 'prop-types';
import Heading from './Heading';
import HeaderShadow from './HeaderShadow';

const Section = (props) => {
  const {
    className,
    headingClassName,
    children,
    heading,
    content,
    setRef,
  } = props;

  return (
    <div className={`blueprint-section section-${className}`} ref={setRef}>
      {heading && (
        <HeaderShadow>
          <Heading>
            <h2 className={headingClassName}>{heading}</h2>
            {content !== null && <div className="content">{content}</div>}
          </Heading>
        </HeaderShadow>
      )}
      {children}
    </div>
  );
};

Section.propTypes = {
  className: PropTypes.node.isRequired,
  headingClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  heading: PropTypes.node,
  content: PropTypes.node,
  setRef: PropTypes.func,
};

Section.defaultProps = {
  headingClassName: '',
  heading: null,
  content: null,
  setRef: () => {},
};

export default Section;
